<template>
  <kst-page-edit
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details 
      :userData="userData"
      :accessOptions="accessOptions"
      :moduleList="moduleList"
      :warehouseOptions="warehouseOptions"
    />
    <TransactionSetting
      :userData="userData"
    />
  </kst-page-edit>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../UserModel.js";
import Services from "../../../services/Api/UserServices.js";

import Details from "./UserE_Details.vue";
import TransactionSetting from "./UserE_TransactionSetting.vue";

export default {
  components: {
    Details,
    TransactionSetting
  },
  mixins: [InputPageMixin],
  data: () => ({
    userData: {},
    accessOptions: {},
    moduleList: [],
    warehouseOptions: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadEdit) {
      this.resetData();

      const config = Services.getEditData(id);
      loadEdit(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      Model.Edit.setDetailsByData(this.userData, data.Details, data.IsReachLimit);
      this.moduleList = data.ModuleList;
      this.accessOptions = Model.createAccessOptions(data.AccessList);
      this.warehouseOptions = Model.getWarehouseOptions(data.WarehouseList);
    },

    handleSubmit(saveData) {
      let data = Model.populateData(this.userData);
      const config = Services.putData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
      this.accessOptions = {};
      this.defaultModuleOptions = {};
      this.warehouseOptions = {};
    }
  }
}
</script>